__webpack_require__.p = "https://bpmrat-tst.bpglobal.com/";